import React from "react";
import './FooterStyle.css';

const Footer =()=>{

    return (
        
<footer className="footer">


    <p className="copyright">
      &copy; 2022 CryptoTech All Rights Reserved by <a href="https://github.com/amalisaah" className="copyright-link">amalisaah</a> & <a href="https://github.com/aihoon01" className="copyright-link">aihoon1</a>
    </p>

</footer>

    )
}

export default Footer